import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { ApprovalProvider } from '../centerWarehouse/facilityInternalRequestApproval/ContextAPI';
import Index from '../centerWarehouse/facilityInternalRequestApproval/Index';
import PermissionDenied from './PermissionDenied';

export default function FacilityInternalRequestCentralApproval() {
    // Route Permission
    const { auth } = useAuth();
    const { route_permissions } = auth;
    if (!route_permissions['facility-internal-request-central-approval'])
        return <PermissionDenied />;

    return (
        <ApprovalProvider>
            <Index />
        </ApprovalProvider>
    );
}
